import { FunctionComponent } from 'react';

const ValidationError: FunctionComponent<{ message?: string }> = (props) => {
  const { message } = props;

  if (message?.length) {
    return (
      <div className="error-message">{message}</div>
    );
  } else {
    return (<></>);
  }
};

export default ValidationError;
